export const DELIVERY_CENARIOS = {
    buscar: {
        id: 'buscar',
        label: 'buscar no local',
        labelCurto: 'Buscar',
        labelStat: 'Buscar no local',
    },
    cozinhar: {
        id: 'cozinhar',
        label: 'cozinhar',
        labelCurto: 'Cozinhar',
        labelStat: 'Cozinhar em casa',
    },
    outra: {
        id: 'outra',
        label: 'outra comida',
        labelCurto: 'Outra comida',
        labelStat: 'Outra comida',
    },
};

/**
 * Compara custo real do delivery vs um cenário concreto
 * (buscar no local / cozinhar / outra comida).
 */
export function simularDelivery({
    precoPrato,
    taxaEntrega = 0,
    gorjeta = 0,
    cupom = 0,
    modo = 'buscar',
    gastoIr = 0,
    custoCenario = null,
    vezesPorMes = 1,
}) {
    const prato = Number(precoPrato);
    const taxa = Number(taxaEntrega) || 0;
    const tip = Number(gorjeta) || 0;
    const desconto = Number(cupom) || 0;
    const vezes = Number(vezesPorMes);

    if (!Number.isFinite(prato) || prato < 0) return null;

    const cenario = DELIVERY_CENARIOS[modo] || DELIVERY_CENARIOS.buscar;
    let custoComparacao;

    if (cenario.id === 'buscar') {
        const ir = Number(gastoIr) || 0;
        if (ir < 0) return null;
        custoComparacao = prato + ir;
    } else {
        const alt = Number(custoCenario);
        if (!Number.isFinite(alt) || alt < 0) return null;
        custoComparacao = alt;
    }

    const custoDelivery = Math.max(0, prato + taxa + tip - desconto);
    const diferenca = custoDelivery - custoComparacao;
    const vezesOk = Number.isFinite(vezes) && vezes > 0 ? vezes : 1;
    const impactoMensal = diferenca * vezesOk;

    let veredicto;
    if (Math.abs(diferenca) < 0.005) {
        veredicto = {
            tipo: 'empate',
            titulo: 'Mesmo custo',
            detalhe: `Pedir delivery e ${cenario.label} saem iguais neste cenário.`,
        };
    } else if (diferenca > 0) {
        veredicto = {
            tipo: 'atencao',
            titulo: `Delivery sai mais caro que ${cenario.label}`,
            detalhe: `Você paga ${diferenca.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} a mais neste pedido. Em ${vezesOk}×/mês: ${impactoMensal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}.`,
        };
    } else {
        veredicto = {
            tipo: 'positivo',
            titulo: `Delivery sai mais barato que ${cenario.label}`,
            detalhe: `Você economiza ${Math.abs(diferenca).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} vs ${cenario.label}. Em ${vezesOk}×/mês: ${Math.abs(impactoMensal).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}.`,
        };
    }

    return {
        custoDelivery,
        custoComparacao,
        custoAlternativa: custoComparacao,
        diferenca,
        impactoMensal,
        vezesPorMes: vezesOk,
        modo: cenario.id,
        labelCenario: cenario.label,
        labelStat: cenario.labelStat,
        veredicto,
    };
}
